import qs from 'qs';
import { AxiosRequestConfig } from 'axios';
import instance, { CRM_REPORT_API_URL } from 'api';
import {
  IArea,
  IRealEstate,
  IUserKPI,
  IUserKPIInfo,
  IUserKPIInfoApplication,
  IUserKPIInfoByWorkType,
  IWorkType,
} from './interfaces';

export const getUsersKPI = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: IUserKPI[]; totalCount: number }>('/kpi/user/list', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getUserKPIInfo = (kpiUserId: number) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IUserKPIInfo>('/kpi/user/infoUser/' + kpiUserId)
    .then((response) => response.data);
};

export const getUserKPIInfoByWorkType = (kpiUserId: number, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<IUserKPIInfoByWorkType[]>(`/kpi/user/infoWorkType/` + kpiUserId, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, skipNulls: true }),
    })
    .then((response) => response.data);
};

export const getUserKPIInfoApplications = (kpiUserId: number, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: IUserKPIInfoApplication[]; totalCount: number }>(`/kpi/user/applications/` + kpiUserId, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, skipNulls: true }),
    })
    .then((response) => response.data);
};

export const exportUserKPIExcel = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get('/kpi/user/list/exportXls', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, skipNulls: true }),
    })
    .then((response) => response.data);
};

export const exportUserKPIPdf = (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get('/kpi/user/list/exportPdf', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, skipNulls: true }),
    })
    .then((response) => response.data);
};

export const exportUserKPIInfoApplicationsExcel = (kpiUserId: number, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get(`/kpi/user/applications/${kpiUserId}/exportXls`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, skipNulls: true }),
    })
    .then((response) => response.data);
};

export const exportUserKPIInfoApplicationsPdf = (kpiUserId: number, config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get(`/kpi/user/applications/${kpiUserId}/exportPdf`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, skipNulls: true }),
    })
    .then((response) => response.data);
};

// dictionaries
export const getAreas = () => {
  return instance()
    .post<IArea[]>('/area/list', {})
    .then((response) => response.data);
};

export const getRealEstates = (
  data: {
    areaIds?: number[];
    includeUnserved?: boolean;
    onlyWithKeytransferDate?: boolean;
    searchWithCity?: boolean;
    nameWithCity?: boolean;
  } = {
    includeUnserved: true,
    onlyWithKeytransferDate: true,
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/v2/realEstatesShort', data)
    .then((response) => response.data);
};

export const getWorkTypes = () => {
  return instance()
    .post<IWorkType[]>('/dictionary/workTypes/list')
    .then((response) => response.data);
};
